<template>
    <Page :header="content[lang].title" :header_pos="'center'">
        <template #body>
            <div class="flex w-full flex-column justify-content-center align-items-center m-auto mb-6" style="max-width:640px;">
                <img src="/images/svg/verify_big_icon.svg" class="max-w-10rem m-auto mb-4">
                <span class="inline-block m-auto justify-content-center align-items-center text-center text-600 text-lg mb-4 line-height-2">
                    {{ content[lang].text }}
                </span>
                <Button :label="content[lang].btn" @click="goProcess" class="p-button-lg w-full max-w-20rem border-round-xl bg-green-200 text-lg text-green-600 border-none"/>
            </div>
            <div class="flex w-full flex-column faqStepsCom m-auto mb-5" style="max-width:640px;">
                <span class="flex text-900 align-items-center text-center font-medium mb-4 xl:mb-6 text-3xl xl:text-4xl lg:text-5xl md:text-4xl justify-content-center">
                    {{ content[lang].subtitle }}
                </span>
                <FaqShortList v-if="tabs" :tabs="tabs" :count="10" />
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue'
import FaqShortList from    '@/components/widgets/FaqList.vue'

export default {
    name: 'verification',
    data() {
        return {
            activeIndex: 0,
            tabs: null,
            content: {
                ru: {
					success: 'Успешно',
					error: 'Ошибка',
					file_uploaded: 'Файл загружен',
					maximum_files: 'Максимальное количество файлов 3',
                    title: 'Верификация',
                    subtitle: 'Как пройти верификацию',
                    text: 'Верификация – это подтверждение вашей личности и контактных данных. Мы обязательно проверим их, чтобы обеспечить безопасность ваших средств и данных.',
                    btn: 'Начать верификацию'
				},
				en: {
					success: 'Success',
					error: 'Error',
					file_uploaded: 'File uploaded',
					maximum_files: 'Maximum files 3',
                    title: 'Verification',
                    subtitle: 'How to pass verification',
                    text: 'Verification is the confirmation of your identity and contact details. We will definitely check them to ensure the security of your funds and data.',
                    btn: 'Start verification'
				}
			},
            tabs: [
                {
                    ru: {
                        title: 'Заполните ваши данные',
                        content: 'Укажите ваши контактные данные, чтобы мы могли их проверить. Вам придет письмо на почту или поступит смс с кодом.'
                    },
                    en: {
                        title: 'Fill in your details',
                        content: 'Specify your contact details so that we can check them. You will receive an email or an SMS with a code.'
                    }
                },
                {
                    ru: {
                        title: 'Отправьте фото паспорта',
                        content: 'Мы не собираемся хранить фото ваших документов. Сразу после проверки паспорта все фото и данные о нем удаляются из системы.'
                    },
                    en: {
                        title: 'Send a photo of your passport',
                        content: 'We are not going to store photos of your documents. Immediately after checking the passport, all photos and data about it are deleted from the system.'
                    }
                },
                {
                    ru: {
                        title: 'Сделайте селфи с паспортом',
                        content: 'Фото вашего лица также нигде не будет храниться. Оно необходимо, чтобы убедиться в достоверности ваших документов.'
                    },
                    en: {
                        title: 'Take a selfie with your passport',
                        content: 'A photo of your face will also not be stored anywhere. It is necessary to make sure of the authenticity of your documents.'
                    }
                }
            ]
        }
    },
    components: {
        Page,
        FaqShortList
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        goProcess(){
            this.$router.push({
                path: '/personal/sender/add/'
            })
        },
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
	}
}
</script>